import React, { useEffect, useState, Fragment } from "react";
import { Card, Col, Container, Row, ModalBody, ModalFooter } from "reactstrap";
import CardCollapse from "components/Common/CardCollapse";
import { useHistory, useParams, Link } from "react-router-dom";
import InputField from "components/form-control/InputField";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import { CommonButton } from "components/Common/ButtonCommon";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import moment from "moment";
import httpService from "services/httpService";
import { useForm } from "react-hook-form";
import VVSTable from "components/form-control/VVSTable";
import UploadFIle from "components/form-control/UploadFile";
import TextareaField from "components/form-control/Textarea";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { uploadFilesApi } from "apis/file";
import SelectConst from "components/form-control/SelectConst";
import toastr from "toastr";
import { formatNumber } from "helpers/erp_helper";
import ModalConfirm from "components/Modal/ModalConfirm";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  setIsConfirm,
} from "redux-toolkit/slices/Modal/ModalSlice";
import {
  GET_CONTRACT,
  GET_EARLY_SETTLE,
  GET_PRODUCTS,
  GET_RENEW_CONTRACT,
  GET_SHOPPING_CART,
} from "helpers/url_helper";
import {
  toastrCRUDSuccess,
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import { TEXT_PUT } from "helpers/name_helper";
import { CommonTextarea } from "components/Common/inputCommon";
import { CommonText } from "components/Common/TextCommon";
import ModalCommon from "components/Common/ModalCommon";
import Spacer from "components/Common/Spacing";
import SelectField from "components/form-control/Select";
import { language_vn } from "helpers/language_vn";

const selectProperty = [
  { index: 0, name: "Đang hiệu lực", value: "effective" },
  { index: 1, name: "Đã tất toán sớm", value: "early-settled" },
  { index: 2, name: "Đã thanh lý", value: "completed" },
  { index: 3, name: "Đang xử lý", value: "pending" },
  { index: 4, name: "Đã huỷ", value: "canceled" },
];

const validationSchema = yup.object().shape({
  attachments: yup.array().min(1, "Đính kèm ít nhất 1 file").required(),
  note: yup.string().required("Hãy ghi gì đó"),
});

const getPeriods = (key, attributes) => {
  const periods = attributes.find(obj => obj.hasOwnProperty(key))[key];
  return Object.keys(periods);
};

const getInvestInformation = (investOption, attributes) => {
  const attribute = attributes.find(obj => obj.hasOwnProperty("newVersion"));
  if (!attribute) return;
  return attribute["newVersion"][investOption];
};

const getPeriodics = investInfo => {
  if (!investInfo?.periods) return;

  return Object.keys(investInfo.periods);
};

const getInvestOptions = attributes => {
  const attribute = attributes.find(obj => obj.hasOwnProperty("newVersion"));
  if (!attribute) return;
  return Object.keys(attribute["newVersion"]);
};

function DetailContract() {
  const isConfirm = useSelector(state => state.Modal.isConfirm);
  const [detailContract, setDetailContract] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [product, setProduct] = useState({});
  const [periods, setPeriods] = useState([]);
  const [selectedPeriods, setSelectedPeriods] = useState(null);
  const [selectedPeriodic, setSelectedPeriodic] = useState(null);
  const [investInformation, setInvestInformation] = useState(null);
  const [periodic, setPeriodic] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [isConfirmActivedContract, setIsConfirmActivedContract] =
    useState(false);
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const { id: code } = params;
  const formProps = useForm({
    mode: "onBlur",
    resolver: yupResolver(validationSchema),
  });

  const {
    register,
    reset,
    getValues,
    handleSubmit,
    formState: { errors },
    setValue,
  } = formProps;
  const [reRenderTransactionTable, setReRenderTransactionTable] =
    useState(false);
  useEffect(() => {
    fetchContractDetail();
  }, []);

  useEffect(() => {
    fetchContractDetail();
  }, [code]);

  const fetchContractDetail = async () => {
    try {
      const url = "/parse/classes/Contract";
      const params = {
        where: { code },
        limit: 1,
        include: [
          "interestRateRef",
          "customer.accounts",
          "customer.accounts.bank",
          "customer.user",
          "order",
          "oldContractRef",
        ],
      };
      const response = await httpService.get(url, { params });
      if (!response.results.length) {
        history.push("/pages-404");
        return;
      }
      const contractSelected = response.results[0];
      const customer = contractSelected.customer;
      customer.wallet = customer.accounts.find(
        account => account.type == "wallet"
      );
      customer.saving = customer.accounts.find(
        account => account.type == "saving"
      );
      customer.bankAccount = customer.accounts
        .filter(account => account.type == "bank")
        .map(account => ({
          value: `${account.accountNumber}`,
          text: `${account.bank.Name || ""} - ${account.accountNumber}`,
        }));
      setDetailContract(contractSelected);
      reset({
        ...contractSelected,
        startDate: {
          iso: moment(contractSelected.startDate.iso).format(
            "yyyy-MM-DD HH:mm"
          ),
        },
        endDate: {
          iso: moment(contractSelected.endDate.iso).format("yyyy-MM-DD HH:mm"),
        },
        total: formatNumber(contractSelected.total),
        balance: formatNumber(customer.saving.balance),
        customer,
        attachments: [],
        estimateInterest: formatNumber(contractSelected?.estimateInterest || 0),
        periodInterest: formatNumber(
          Math.round(
            (contractSelected?.total *
              (contractSelected?.baseRate + contractSelected?.bonusRate) *
              Number(contractSelected?.periodic)) /
              12 /
              100
          ) ||
            Math.round(
              (contractSelected?.total *
                contractSelected?.rate *
                Number(contractSelected?.periodic)) /
                12 /
                100
            )
        ),
        baseRate: contractSelected?.baseRate || contractSelected?.rate,
      });
      setValue(
        "customer.wallet.balance",
        formatNumber(customer.wallet.balance) || 0
      );
    } catch (err) {
      console.log(err);
    }
    try {
      const response = await httpService.get(GET_CURRENT_USER);
      setCurrentUser(response);
    } catch (err) {
      console.log("Api get creator failed");
    }
  };

  const handleSaveNote = async values => {
    try {
      const firstIndexUnUploaded = values.attachments.findIndex(
        attachment => !attachment.url
      );
      const responseUploadFiles = await uploadFilesApi(
        values.attachments.slice(firstIndexUnUploaded)
      );
      values.attachments.splice(
        firstIndexUnUploaded,
        responseUploadFiles.length,
        ...responseUploadFiles
      );
      const postAttachmentFormat = {
        note: values.note,
        attachments: values.attachments,
        contract: {
          __type: "Pointer",
          className: "Contract",
          objectId: getValues("objectId"),
        },
        createdBy: {
          __type: "Pointer",
          className: "_User",
          objectId: currentUser?.objectId || "",
        },
      };
      try {
        const url = "/parse/classes/ContractAttachment";
        await httpService.post(url, postAttachmentFormat);
        toastr.success("Tạo ghi chú thành công");
        setValue("note", "");
        setValue("attachments", []);
        setReRenderTransactionTable(prev => !prev);
      } catch (err) {
        console.log(err);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const renderCustomerInfo = (
    <>
      <Row>
        <Col xs={4}>
          <InputField
            label={
              <Fragment>
                Mã khách hàng
                <Link to={`/customer/${getValues("customer.objectId")}`}>
                  (chi tiết)
                </Link>
              </Fragment>
            }
            register={register}
            readOnly
            name="customer.code"
          />
        </Col>
        <Col xs={4}>
          <InputField
            label="Họ tên"
            register={register}
            readOnly
            name="customer.fullName"
          />
        </Col>
        <Col xs={4}>
          <InputField
            label="Số điện thoại"
            register={register}
            readOnly
            name="customer.phone"
          />
        </Col>
        <Col xs={4}>
          <InputField
            label="Email"
            register={register}
            readOnly
            name="customer.email"
          />
        </Col>
        <Col xs={4}>
          <InputField
            label="Số dư ví cá nhân"
            register={register}
            readOnly
            name="customer.wallet.balance"
          />
        </Col>
        <Col xs={4}>
          <SelectConst
            label="Danh sách tài khoản ngân hàng"
            options={getValues(`customer.bankAccount`)}
            disableEmptyOption
          />
        </Col>
      </Row>
      <VVSTable
        name="CustomerAccount"
        whereQuery={{
          type: "bank",
          customer: {
            __type: "Pointer",
            className: "Customer",
            objectId: getValues("customer.objectId"),
          },
        }}
        disableAdd
        disableDelete
        disableSearch
        className="m-0 p-0 shadow-none"
      />
    </>
  );
  const renderAttachment = (
    <React.Fragment>
      <Row>
        <Col xs={4}>
          <UploadFIle
            name="attachments"
            label="Nhấn để đính kèm file"
            errors={errors}
            {...formProps}
          />
        </Col>
        <Col xs={8}>
          <TextareaField
            register={register}
            name="note"
            rows={10}
            label={<strong>Ghi chú</strong>}
            required
            errors={errors}
          />
        </Col>
      </Row>
      <VVSTable
        name="ContractAttachment"
        disableAdd
        disableDelete
        disableSearch
        whereQuery={{
          contract: {
            __type: "Pointer",
            className: "Contract",
            objectId: getValues("objectId") || "",
          },
        }}
        triggerRerender={reRenderTransactionTable}
      />
    </React.Fragment>
  );
  const renderSavingHistory = getValues("objectId") ? (
    <>
      <VVSTable
        name="TransactionContract"
        disableDelete
        disableAdd
        disableSearch
        whereQuery={{
          contract: {
            __type: "Pointer",
            className: "Contract",
            objectId: getValues("objectId"),
          },
        }}
        styleViewTopTable={{
          paddingTop: "0px",
          marginTop: "-10px",
        }}
      />
    </>
  ) : null;

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleOpenModal = () => {
    dispatch(setIsConfirm(true));
  };

  const handleContractCancel = async () => {
    if (!detailContract) return;
    try {
      const res = await httpService.put(
        GET_CONTRACT + `/${detailContract.objectId}`,
        {
          status: "canceled",
        }
      );

      if (res?.updatedAt) {
        setValue("status", "canceled");
        toastrSuccessAlert("Huỷ hợp đồng thành công!");
      }
    } catch (error) {
      console.log("error", error);
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!");
    }
  };

  const handleContractLiquidation = async () => {
    if (!detailContract) return;
    try {
      const res = await httpService.post(GET_EARLY_SETTLE, {
        contractId: detailContract.objectId,
      });

      if (res?.result.code === 0) {
        setValue("status", "completed");
        toastrSuccessAlert("Thanh lý hợp đồng thành công!");
        return;
      }

      toastrErrorAlert(language_vn.error);
    } catch (error) {
      console.log("error", error);
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!");
    }
  };

  const handleContractSave = async () => {
    try {
      const res = await httpService.put(
        GET_CONTRACT + `/${detailContract.objectId}`,
        {
          note: getValues("note"),
        }
      );

      if (res?.updatedAt) {
        toastrSuccessAlert("Lưu hợp đồng thành công!");
      }
    } catch (error) {
      console.log("error", error);
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!");
    }
  };

  const openModalRenewContract = async () => {
    try {
      setToggle(prev => !prev);
      const res = await httpService.get(
        GET_PRODUCTS + `/${detailContract?.order?.orderItems[0].productId}`
      );

      setProduct(res);
      const periods = getPeriods("durations", res.attributes);

      const investInformation = getInvestInformation(
        detailContract.investment,
        res.attributes
      );
      const periodics = getPeriodics(investInformation);

      setPeriodic(periodics);
      setPeriods(periods);
      setSelectedPeriods(periods[0]);
      setSelectedPeriodic(periodics[0]);
      setInvestInformation(investInformation);
    } catch (error) {}
  };

  const handleActivedContract = async () => {
    try {
      setIsConfirmActivedContract(false);
      const res = await httpService.put(
        GET_CONTRACT + `/${detailContract.objectId}`,
        {
          status: "effective",
        }
      );

      if (res?.updatedAt) {
        setValue("status", "effective");
        toastrSuccessAlert("Cập nhật hợp đồng thành công!");
        return;
      }
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!");
    } catch (error) {
      console.log("error", error);
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!");
    }
  };

  const getInterestRateByPeriod = (price, period, periodic, rate) => {
    if (Number(periodic) !== 12 || price < 50000000) return rate;

    switch (Number(period)) {
      case 24:
        return rate + 1;
      case 36:
        return rate + 2;
      case 48:
        return rate + 3;
      case 60:
        return rate + 4;
      default:
        return rate;
    }
  };

  const handleRenewContract = async () => {
    // const resShoppingCart = await httpService.post(GET_SHOPPING_CART, {
    //   customerId: detailContract?.customer.objectId,
    //   items: [
    //     {
    //       productId: product?.objectId,
    //       quantity: 1,
    //     },
    //   ],
    //   noPeriods: Number(selectedPeriods),
    //   periodic: Number(selectedPeriodic),
    //   note: detailContract?.investment,
    //   useMasterKey: true,
    // });

    // const resRenewContract = await httpService.post(GET_RENEW_CONTRACT, {
    //   contractId: detailContract?.objectId,
    //   noPeriods: Number(selectedPeriods),
    //   periodic: Number(selectedPeriodic),
    //   signature: detailContract?.signature,
    //   productId: product?.objectId,
    // });
    // console.log("resRenewContract", resRenewContract);

    toastrErrorAlert(
      "Hiện tại chức năng này chưa hoàn thiện. Vui lòng thử lại sau!!"
    );
    setToggle(prev => !prev);
  };

  const openContract = () => {
    window.open(
      `https://vsgroup.vvs.vn/api/v1/pages/contract-${
        detailContract.investment === "TRƯƠNG GIA"
          ? "truong-gia"
          : detailContract.investment.toLowerCase().split(" ").join("-")
      }/${detailContract.objectId}`,
      "_blank"
    );
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <HeaderCreateItem title={`Chi tiết hợp đồng ${code}`}>
            <div className="d-flex align-items-center mb-2">
              <div className="flex-grow-1"></div>

              <div style={{ width: "12px" }} />
              {detailContract.status === "pending" && (
                <CommonButton
                  level={0}
                  onClick={() => {
                    setIsConfirmActivedContract(true);
                  }}
                >
                  Kích hoạt hợp đồng
                </CommonButton>
              )}

              {/* <CommonButton level={0} onClick={openModalRenewContract}>
                Tái ký
              </CommonButton> */}
              {detailContract.status === "effective" &&
                moment().isAfter(detailContract?.endDate?.iso) && (
                  <>
                    <div style={{ width: "12px" }} />
                    <CommonButton level={0} onClick={handleContractLiquidation}>
                      Thanh lý
                    </CommonButton>
                  </>
                )}

              {/* {detailContract?.status !== "canceled" &&
                detailContract.status !== "completed" && (
                  <>
                    <div style={{ width: "12px" }} />
                    <CommonButton level={2} onClick={handleOpenModal}>
                      Huỷ
                    </CommonButton>
                  </>
                )} */}

              <div style={{ width: "12px" }} />
              <CommonButton level={3} onClick={handleContractSave}>
                Lưu
              </CommonButton>
            </div>
          </HeaderCreateItem>
          <form>
            <Card body>
              <Row>
                <Col>
                  <InputField
                    label="Mã hợp dồng"
                    register={register}
                    readOnly
                    name="code"
                  />
                </Col>
                <Col>
                  <InputField
                    label="Kỳ hạn"
                    register={register}
                    readOnly
                    name="noPeriods"
                  />
                </Col>
                <Col>
                  <InputField
                    label="Chu kỳ rút lãi"
                    register={register}
                    readOnly
                    name="periodic"
                  />
                </Col>

                <Col>
                  <SelectField
                    label="Trạng thái"
                    register={register}
                    name="status"
                    options={selectProperty}
                    disabled
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputField
                    label="Tổng lãi dự kiến"
                    register={register}
                    readOnly
                    name="estimateInterest"
                  />
                </Col>
                <Col>
                  <InputField
                    label="Lãi theo chu kỳ"
                    register={register}
                    readOnly
                    name="periodInterest"
                  />
                </Col>
                <Col>
                  <InputField
                    label="Lãi suất cố định"
                    register={register}
                    readOnly
                    name="baseRate"
                  />
                </Col>
                <Col>
                  <InputField
                    label="Lãi suất thưởng"
                    register={register}
                    readOnly
                    name="bonusRate"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputField
                    label="Tổng giá trị"
                    register={register}
                    readOnly
                    name="total"
                  />
                </Col>
                <Col>
                  <InputField
                    label="Nơi đầu tư"
                    register={register}
                    readOnly
                    name="investment"
                  />
                </Col>
                <Col>
                  <Row>
                    <CommonText>Thời gian bắt đầu</CommonText>
                    <CommonText>
                      {detailContract &&
                        moment(detailContract?.startDate?.iso).format(
                          "DD-MM-YYYY"
                        )}
                    </CommonText>
                  </Row>
                </Col>
                <Col>
                  <Row>
                    <CommonText>Thời gian kết thúc</CommonText>
                    <CommonText>
                      {detailContract &&
                        moment(detailContract?.endDate?.iso).format(
                          "DD-MM-YYYY"
                        )}
                    </CommonText>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col sm={3}>
                  {!moment(detailContract?.startDate?.iso).isBefore(
                    "2022-10-20"
                  ) && (
                    <p
                      className="mt-3"
                      style={{
                        fontWeight: "600",
                        color: "#556ee6",
                        cursor: "pointer",
                      }}
                      onClick={openContract}
                    >
                      Xem hợp đồng
                    </p>
                  )}
                </Col>
                <Col sm={3}>
                  {detailContract?.oldContractRef && (
                    <p
                      className="mt-3"
                      style={{
                        fontWeight: "600",
                        cursor: "pointer",
                      }}
                    >
                      Được tái kí từ HĐ -{" "}
                      <strong
                        className="text-danger"
                        onClick={() => {
                          history.push(
                            `/contract/${detailContract?.oldContractRef?.code}`
                          );
                        }}
                      >
                        {" "}
                        {detailContract?.oldContractRef?.code}
                      </strong>
                    </p>
                  )}
                </Col>
              </Row>
            </Card>
          </form>
          <Card body>
            <CommonText className={"form-label"}>Ghi chú</CommonText>
            <CommonTextarea
              className="form-control"
              {...register("note")}
              rows={"6"}
            />
          </Card>
          <CardCollapse
            element={renderCustomerInfo}
            title="Thông tin khách hàng"
            defaultFlag={true}
          />

          <CardCollapse
            element={renderAttachment}
            title="File đính kèm"
            defaultFlag={false}
            topRightElement={
              <CommonButton
                level={0}
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleSubmit(handleSaveNote)();
                }}
              >
                Lưu
              </CommonButton>
            }
          />
          <CardCollapse
            element={renderSavingHistory}
            defaultFlag={true}
            title="Lịch sử giao dịch"
          />
          <ModalConfirm
            toggle={handleCloseModal}
            isOpen={isConfirm}
            title="Bạn có chắc chắn muốn huỷ hợp đồng này hay không?"
            onConfirm={handleContractCancel}
          />
          <ModalConfirm
            toggle={() => {
              setIsConfirmActivedContract(false);
            }}
            isOpen={isConfirmActivedContract}
            title="Bạn có chắc chắn muốn kích hoạt hợp đồng này hay không?"
            onConfirm={handleActivedContract}
          />
          <ModalCommon
            modalTitle="Tái ký gói đầu tư"
            isShowModal={toggle}
            size="lg"
            onClose={() => {
              setToggle(prev => !prev);
            }}
          >
            <ModalBody>
              <Spacer size={20} />
              <h5>Kỳ hạn</h5>
              <div
                className="d-flex gap-3 mt-3"
                style={{ alignItems: "center" }}
              >
                {periods.map((item, index) => {
                  return (
                    <div
                      key={index + "periods"}
                      onClick={() => setSelectedPeriods(item)}
                      style={
                        selectedPeriods === item
                          ? {
                              border: "1px solid #118B42",
                              padding: "10px",
                              borderRadius: 8,
                              cursor: "pointer",
                              color: "#118B42",
                            }
                          : {
                              border: "1px solid #9095A6",
                              padding: "10px",
                              borderRadius: 8,
                              cursor: "pointer",
                              color: "#9095A6",
                            }
                      }
                    >
                      <p className="mb-0">{item} tháng</p>
                    </div>
                  );
                })}
              </div>
              <h5 className="mt-4">Chu kỳ rút lãi</h5>
              <div
                className="d-flex gap-3 mt-3 "
                style={{ alignItems: "center" }}
              >
                {periodic.map((item, index) => {
                  return (
                    <div
                      key={index + "periods"}
                      onClick={() => setSelectedPeriodic(item)}
                      style={
                        selectedPeriodic === item
                          ? {
                              border: "1px solid #118B42",
                              padding: "10px",
                              borderRadius: 8,
                              cursor: "pointer",
                              color: "#118B42",
                            }
                          : {
                              border: "1px solid #9095A6",
                              padding: "10px",
                              borderRadius: 8,
                              cursor: "pointer",
                              color: "#9095A6",
                            }
                      }
                    >
                      <p className="mb-0">{item} tháng</p>
                    </div>
                  );
                })}
              </div>
              <div className="d-flex gap-2 mt-3">
                <p>Tổng thanh toán:</p>
                <strong>{formatNumber(product?.sellingPrice) || 0} đ</strong>
              </div>
              <div className="d-flex gap-2">
                <p>Lãi suất</p>
                <strong>
                  {" "}
                  {getInterestRateByPeriod(investInformation?.interest)} %
                </strong>
              </div>
              <div className="d-flex gap-2">
                <p>Lãi suất thưởng</p>
                <strong>
                  {" "}
                  {investInformation?.periods[selectedPeriodic]?.bonus} %
                </strong>
              </div>
              <div className="d-flex gap-2">
                <p>Tiền lãi theo chu kỳ</p>
                <strong>
                  {formatNumber(
                    Math.round(
                      (product?.sellingPrice *
                        (investInformation?.interest +
                          investInformation?.periods[selectedPeriodic]?.bonus) *
                        Number(selectedPeriodic)) /
                        12 /
                        100
                    )
                  )}{" "}
                  đ
                </strong>
              </div>
              <div className="d-flex gap-2">
                <p>Tổng tiền nhận được sau khi hết hạn kỳ</p>
                <strong>
                  {formatNumber(
                    Math.round(
                      (product?.sellingPrice *
                        (investInformation?.interest +
                          investInformation?.periods[selectedPeriodic]?.bonus) *
                        Number(selectedPeriods)) /
                        12 /
                        100 +
                        product?.sellingPrice
                    )
                  )}{" "}
                  đ
                </strong>
              </div>
              <Spacer size={20} />
            </ModalBody>
            <ModalFooter>
              <CommonButton
                level={0}
                onClick={() => {
                  setToggle(prev => !prev);
                }}
              >
                Huỷ
              </CommonButton>
              <CommonButton level={3} onClick={handleRenewContract}>
                Đồng ý
              </CommonButton>
            </ModalFooter>
          </ModalCommon>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default DetailContract;
